export const UHCStateAcronyms = ['CA', 'CO', 'HI', 'ME', 'MD', 'MD', 'MN', 'RI', 'UT']
